var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37564 3.20173C4.74776 3.20173 4.12045 3.42875 3.64239 3.88336C3.18492 4.3191 2.93274 4.89723 2.93274 5.51139C2.93274 6.12497 3.18492 6.7031 3.64239 7.13884L7.50745 10.8169L11.3725 7.13884C11.83 6.7031 12.0822 6.12497 12.0822 5.51139C12.0822 4.8978 11.83 4.3191 11.3725 3.88336C10.417 2.97414 8.86247 2.97414 7.90602 3.88336L7.50745 4.26306L7.10888 3.88336C6.63082 3.42875 6.00352 3.20173 5.37564 3.20173ZM7.50745 12.378L2.84525 7.94107C2.16419 7.29317 1.78906 6.43027 1.78906 5.51132C1.78906 4.59238 2.16419 3.72947 2.84525 3.08101C4.11473 1.87271 6.10759 1.76406 7.50745 2.75334C8.90732 1.76406 10.9002 1.87271 12.1697 3.08101C12.8507 3.72947 13.2258 4.59238 13.2258 5.51132C13.2258 6.43027 12.8507 7.29317 12.1697 7.94107L7.50745 12.378Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.00dcf296.svg";
export { ForwardRef as ReactComponent };